import React, { useEffect, useState, useLayoutEffect } from 'react';

import ControllersSection from './ControllerSection';
import CMS from './CMS';
import App from './App';
import { Button } from '../../Atoms';

import Banner from './Banner';

export default function IoTSolutions() {
  useLayoutEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <Banner />
      <ControllersSection />
      <CMS />
      <App />
    </>
  );
}
